const NO_EMAIL_ON_FILE = 'No email on file';

export const formatMaskedEmail = (maskedEmail?: string | null) => {
  return maskedEmail?.trim() ? maskedEmail : NO_EMAIL_ON_FILE;
};
